import type {
  ProvisionType,
  UserType,
} from '../graphql/generated/graphqlTypes';

const canAuthenticateWithPassword = (
  organization: {
    settings: { authentication: string };
    ssoPlatforms: string[];
  },
  userType?: UserType | ProvisionType,
) => {
  const authenticationSetting = organization.settings.authentication;

  return (
    authenticationSetting === 'SSO_AND_PASSWORD' ||
    (authenticationSetting === 'SSO_AND_GUEST_PASSWORD' &&
      userType === 'GUEST') ||
    organization.ssoPlatforms.length === 0
  );
};

export default canAuthenticateWithPassword;
